import React, {useEffect} from 'react';
import {withRouter} from 'react-router-dom';
import Error from './error';

function Utilities({children, location: {pathname}}) {

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [pathname]);

  return (
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
      ||
      void 0
  );
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: false,
    };
  }

  static getDerivedStateFromError(error) {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return <Error/>;
    }
    return this.props.children;
  }
}

export default withRouter(Utilities);
